<style lang="less" scoped>
.legalPerson {
  width: 100%;
  min-height: 100%;
  background-color: #f0f2f6;
    .protocolText {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;
    padding: 0.466667rem 0.666667rem;
    box-sizing: border-box;
    line-height: 0.6rem;
    z-index: 9999;
    text-align: left;
    color: #333333;
    .title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
      text-align: center;
    }
    .name {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 90px;
    }
    .haveRead {
      width: 70%;
      margin: 0 auto;
      margin-top: 30px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      background-color: #53b7f6;
    }
  }
  .roof {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #21aaff;
    font-size: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    svg {
      margin-right: 20px;
    }
  }
  .header {
    width: 100%;
    background: url("data:image/png;base64,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");
    background-size: 100% 100%;
    .tabs {
      width: 692px;
      height: 153px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      display: flex;
      .item {
        flex: 1;
        text-align: center;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-top: 35px;
        box-sizing: border-box;
        position: relative;
        img {
          width: 52px;
          height: 52px;
        }
        .jiantou {
          width: 15px;
          height: 26px;
          position: absolute;
          right: 0;
          bottom: 30px;
        }
      }
      .item:first-child {
        color: #21aaff;
      }
    }
  }
  .tabOne {
      position: relative;
  width: 100%;
  height: 100%;
    .idCard {
      width: 692px;
      height: 323px;
      margin: 0 auto;
      margin-top: 30px;
      background-color: #fff;
      padding: 40px;
      box-sizing: border-box;
      border-radius: 20px;
      .name {
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .idcodeimg {
        width: 561px;
        margin: 0 auto;
        margin-top: 27px;
        overflow: hidden;
        .codeleft {
          float: left;
          width: 267px;
          height: 167px;
          border-radius: 10px;
          border: 1px solid rgba(33, 170, 255, 1);
        }
        .coderight {
          float: right;
          width: 267px;
          height: 167px;
          border-radius: 10px;
          border: 1px solid rgba(33, 170, 255, 1);
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .main {
      width: 692px;
      margin: 0 auto;
      margin-top: 30px;
      border-radius: 20px;
      padding: 35px;
      padding-bottom: 0px;
      box-sizing: border-box;
      background-color: #fff;
      .tip {
        font-size: 26px;
        padding: 10px 0px 0px 20px;
        color: red;
      }
      .name {
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .items {
        width: 525px;
        margin: 30px auto;
        display: flex;
        font-size: 22px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        div {
          flex: 1;
          text-align: center;
          img {
            width: 113px;
            height: 90px;
            margin-bottom: 20px;
            // border: 1px solid #ccc;
          }
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            i {
              margin-right: 10px;
            }
          }
        }
      }

  .arguments {
        color: #a2a2a2;
        font-size: 1.08em;
        text-align: center;
        padding: 20px;
          border-top: 1px solid rgba(219, 219, 219, 1);
        .input_check{
          vertical-align: middle;
        }
        a {
          color: #3083ff;
        }
      }
      .main-input {
        width: 100%;
        height: 87px;
        line-height: 87px;
        border-top: 1px solid rgba(219, 219, 219, 1);
        font-size: 28px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
            padding-top: 5px;
                a {
          color: #3083ff;
        }
      }
    }
  }
  .nextStep {
    width: 9.093333rem;
    height: 1.253333rem;
    margin: 0 auto;
    padding-top: 40px
    // line-height: 94px;
    // margin-top: 35px;
    // text-align: center;
    // background: rgba(33, 170, 255, 1);
    // border-radius: 20px;
    // font-size: 36px;
    // font-family: MicrosoftYaHei;
    // font-weight: 400;
    // color: rgba(255, 255, 255, 1);
  }
}
</style>

<style>
.legalPerson .codeleft .nut-imagepicker .img-list .add-icon {
  width: 267px;
  height: 167px;
  position: relative;
  border: none;
  background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_383515910831670212020215324721idCodez.png")
    no-repeat;
  background-size: 100% 100%;
}
.legalPerson .coderight .nut-imagepicker .img-list .add-icon {
  width: 267px;
  height: 167px;
  position: relative;
  border: none;
  background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_1585159108359080520202153950805idCodeb.png")
    no-repeat;
  background-size: 100% 100%;
}
.legalPerson .nut-imagepicker .img-list .img-item a img {
  display: inline-block;
  width: 267px;
  height: 167px;
}
.legalPerson .nut-imagepicker .img-list .add-icon i {
  display: none;
}
.legalPerson .nut-button.block {
  height: 70px !important;
  font-size: 30px !important;
  background: #21aaff;
}
.legalPerson .nut-button[disabled] {
  background: #dadada !important;
  color: #f6f6f6 !important;
}
.legalPerson .nut-textinput input {
  height: 80px !important;
  width: 430px !important;
}
.legalPerson .nut-textinput-label {
  font-size: 28px !important;
}
.legalPerson .nut-checkbox input:checked {
  background-color: #21aaff !important;
  border-color: #21aaff !important;
}
.legalPerson .nut-button[disabled] {
  background: #dadada !important;
  color: #f6f6f6 !important;
}
.legalPerson .nut-checkbox input {
  background: #ddd;
  width: 30px !important;
  height: 30px !important;
}
/* .legalPerson .nut-checkbox.nut-checkbox-size-base input {
  width: 30px !important;
  height: 30px !important;
}

.legalPerson .nut-checkbox input {
  border-color:red !important;
} */
</style>

<template>
  <div class="legalPerson">
    <div class="protocolText"
         v-if="proType">
      <registerArguments></registerArguments>
      <div class="haveRead"
           @click="butongyi">已阅读</div>
    </div>
    <div class="roof"
         @click="back">
      <svg t="1591005918644"
           class="icon"
           viewBox="0 0 1024 1024"
           version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           p-id="1100"
           width="20"
           height="20">
        <path d="M511.609097 961.619254"
              p-id="1101"
              fill="#ffffff"></path>
        <path d="M360.749204 511.010463 360.749204 511.010463l382.080022-382.074905c14.762215-14.788821 14.762215-38.777165 0-53.585429-14.812357-14.788821-38.799678-14.788821-53.607942 0L283.415908 481.201553c-1.107217 0.867764-2.190899 1.824555-3.206018 2.843768-14.788821 14.808264-14.788821 38.795585 0 53.585429l408.226518 408.230612c14.808264 14.807241 38.795585 14.807241 53.584406 0 14.785751-14.767332 14.785751-38.754652 0-53.562916L360.749204 511.010463 360.749204 511.010463zM360.749204 511.010463"
              p-id="1102"
              fill="#ffffff"></path>
      </svg>个人信息填写
    </div>
    <!-- <div class="header">
      <div class="tabs">
        <div class="item" v-for="(o, i) in tabsArr" :key="i">
          <img :src="o.icon" alt="" />
          <div>{{ o.name }}</div>
          <img
            v-if="i == 0"
            class="jiantou"
            src="/static/images/fanhui-25.png"
            alt=""
          />
          <img
            v-if="i == 1"
            class="jiantou"
            src="/static/images/fanhui-251.png"
            alt=""
          />
        </div>
      </div>
    </div> -->
    <div class="tabOne">
      <div class="idCard">
        <div class="name">- 上传个人身份证拍照件或者扫描件 -</div>
        <div class="idcodeimg">
          <div class="codeleft">
            <nut-imagepicker width="null"
                             height="null"
                             @imgMsg="tupian"
                             :max="1"
                             :imgList.sync="imgList1">
            </nut-imagepicker>
            <!-- <img
              :src="idCodez ? idCodez : '/static/images/idCodez.png'"
              alt=""
            > -->
          </div>
          <div class="coderight">
            <nut-imagepicker width="null"
                             height="null"
                             @imgMsg="tupian2"
                             :max="1"
                             :imgList.sync="imgList2">
            </nut-imagepicker>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="name">*拍摄须知</div>
        <div class="tip">
          上传个人身份证拍照件，请确保图片清晰，若拍摄不符合要求会被驳回
        </div>
        <div class="items">
          <div v-for="(item, key) in shootingArr"
               :key="key">
            <img :src="item.img"
                 alt="" />
            <div>
              <nut-icon :type="item.icon"
                        :color="item.color"> </nut-icon>
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="main-input">
          <!-- <span>法人姓名</span> -->
          <nut-textinput style="padding-left: 0.7rem"
                         v-model="methodName"
                         label="姓名："
                         placeholder="请填写姓名名称"
                         :has-border="false"
                         :clearBtn="true" />
        </div>
        <!-- <div class="main-input"><span>联系手机</span><input
            type="text"
            v-model="methodPhone"
            maxlength="11"
            placeholder="必须是法人本人手机，用于实名认证"
          ></div> -->
        <div class="main-input">
          <nut-textinput v-model="methodIdentity"
                         label="身份证号："
                         placeholder="请上传身份证"
                         :has-border="false"
                         :clearBtn="true"
                         @change="baoguoBtn"
                         readonly />
          <!-- <span>身份证号</span><input
            type="text"
            v-model="methodIdentity"
            maxlength="18"
            placeholder="请填写身份证号"
          > -->
        </div>
        <div class="main-input">
          <!-- <span>手机号</span> -->
          <!-- <div
          class="main-code"
          :style="'background-color:' + color"
          v-if="bank_mobile"
          @click="noteSend"
        >
          {{ noteType ? noteTime : "获取验证码" }}
        </div> -->
          <div class="main-code1"></div>
          <!-- <input type="text" style="width:calc(80% - 150px);" v-model="bank_mobile" maxlength="11" placeholder="请填写银行预留手机号"> -->
          <nut-textinput v-model="bank_mobile"
                         maxlength="11"
                         style="padding-left: 0.4rem"
                         label="手机号： "
                         placeholder="请填写银行预留手机号"
                         @change="mobileInfo"
                         :has-border="false"
                         :clearBtn="true"
                         :disabled="false" />
        </div>
        <div class="main-input"
             style="display: flex; justify-content: space-between">
          <!-- <span>银行卡号</span><input type="text" v-model="bank_no" maxlength="30" placeholder="请填写银行卡号"> -->
          <nut-textinput v-model="bank_no"
                         label="银行卡号： "
                         placeholder="请填写银行卡号"
                         :has-border="false"
                         @change="hideInfo"
                         :clearBtn="true"
                         :disabled="false"
                         width="200">
          </nut-textinput>
          <nut-uploader :url="url"
                        @success="onSuccess"
                        @showMsg="showMsgFn">
            <i class="iconfont iconsaoyisao"
               style="font-size: 20px"></i>
          </nut-uploader>
        </div>

        <div class="arguments">
          <!-- <nut-checkbox
            v-model="agreeArguments"
             size="large"
            @change="dianjiPost"
            class="my-check"
          ></nut-checkbox> -->
          <span>
            <input type="checkbox"
                   class="input_check"
                   v-model="agreeArguments"
                   @click="dianjiPost" />
            <span>
              阅读并同意
              <a @click="showArguments">《自由职业者服务框架协议》</a></span>
          </span>
        </div>
      </div>
    </div>

    <div class="nextStep">
      <nut-button block
                  shape="circle"
                  :disabled="disabled"
                  @click="nextStep">
        下一步
      </nut-button>
    </div>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";
import bus from "../../utils/bus.js";
import registerArguments from "../../components/RegisterArguments";

export default {
  data() {
    return {
      url: config.bankcard,
      shootingArr: [
        {
          img: "/static/images/sicon1.png",
          name: "标准拍摄",
          icon: "tick",
          color: "#32C3A9",
        },
        {
          img: "/static/images/sicon2.png",
          name: "边框缺失",
          icon: "cross",
          color: "#FF3A1A",
        },
        {
          img: "/static/images/sicon1.png",
          name: "照片模糊",
          icon: "cross",
          color: "#FF3A1A",
        },
        {
          img: "/static/images/sicon4.png",
          name: "闪光强烈",
          icon: "cross",
          color: "#FF3A1A",
        },
      ],
      tabsArr: [
        { icon: "/static/images/icon-test-5.png", name: "个人信息" },
        // { icon: "/static/images/gongsi1.png", name: "公司信息" },
        { icon: "/static/images/yinxingqia-31.png", name: "银行卡" },
      ],
      idCodez: null,
      idCodeb: null,
      methodName: null,
      methodNameUpdate: null,
      methodIdentityUpdate: "",
      methodPhone: null,
      methodIdentity: "",
      idNumber: "", //身份证号
      idcardIsImg: null,
      idcardIsImged: null,
      disabled: true,
      idcardTheImg: null,
      bank_mobile: null,
      cellphoneNumber: null, //手机号
      bank_no: null,
      bankcardNumber: null, //银行卡号
      bank_noed: null,
      bank_mobiled: null,
      agreeArguments: false,
      proType: false,
      idCardType: "",
      imgCode: 2,
      imgList1: [
        {
          id: 1,
          src: "",
        },
      ],
      imgList2: [
        {
          id: 2,
          src: "",
        },
      ],
      data: {
        d: {},
        action: "",
      },
    };
  },
  computed: {},
  components: {
    registerArguments: registerArguments,
  },
  mounted() {
    if (sessionStorage.getItem("esignappsid")) {
      this.saasorderbusinessmenPagePost();
    }
  },
  methods: {
    baoguoBtn(e) {
      let str = e.target.value;
      if (str.indexOf("*") == -1) {
        this.idNumber = str;
      } else {
        let arr = str.split("");
        // console.log(arr)
        let arr2 = this.idNumber.split("");
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] != "*") {
            arr2.splice(i, 1, arr[i]);
            // console.log(arr[i],'baowei')
          }
          this.idNumber = arr2.join("");
        }
      }
      str = `${str.substring(0, 4)}**********${str.substring(str.length - 4)}`;
      if (!this.methodIdentityUpdate) {
        this.methodIdentity = str;
      }
    },
    butongyi() {
      this.proType = false;
      this.agreeArguments = true;
      http
        .post(config.frame, {
          deviceType: 4,
          sourceClient: 21,
        })
        .then((e) => {
          // console.log(e);
          if (e.code == 0) {
          } else {
            this.$toast.fail(e.message);
          }
        });
    },
    dianjiPost(checked) {
      http
        .post(config.frame, {
          deviceType: 4,
          sourceClient: 21,
        })
        .then((e) => {
          // console.log(e);
          if (e.code == 0) {
          } else {
            this.$toast.fail(e.message);
          }
        });
    },
    showArguments() {
      this.proType = true;
    },
    mobileInfo(e) {
      let str = e.target.value;
      if (str.indexOf("*") == -1) {
        this.cellphoneNumber = str;
      } else {
        let arr = str.split("");
        // console.log(arr)
        let arr2 = this.cellphoneNumber.split("");
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] != "*") {
            arr2.splice(i, 1, arr[i]);
            // console.log(arr[i],'baowei')
          }
          this.cellphoneNumber = arr2.join("");
        }
      }
      str = `${str.substring(0, 3)}****${str.substring(str.length - 4)}`;
      if (!this.bank_mobiled) {
        this.bank_mobile = str;
      }
    },
    hideInfo(e) {
      // console.log(e.target.value);
      let str = e.target.value;
      if (str.indexOf("*") == -1) {
        this.bankCardNumber = str;
      } else {
        let arred = str.split("");
        // console.log(arred, "银行卡对对对");
        let arr2 = this.bankCardNumber.split("");
        for (let i = 0; i < arred.length; i++) {
          if (arred[i] != "*") {
            // console.log(i, arred[i], "666666666666");
            arr2.splice(i, 1, arred[i]);
            // console.log(arr2, "1111111111111");
          }
          this.bankCardNumber = arr2.join("");
          //  console.log(arr2,'baowei')
        }
      }
      str = `${str.substring(0, 4)}${"*".repeat(str.length - 8)}${str.length % 4 ? "" : ""
        }${str.slice(-4)}`;
      if (!this.bank_noed) {
        this.bank_no = str;
      }
    },
    onSuccess(file, res) {
      // console.log(JSON.parse(res), "11111");
      var resData = JSON.parse(res);
      if (resData.code == 0) {
        // console.log(res.data.data, "55555555555");
        if (resData.data.code == 200) {
          this.$toast.success(resData.data.msg);
          // console.log(resData.data, "1111111111111111");
          if (resData.data.bankCardNumber) {
            var bankNumber = resData.data.bankCardNumber;
            this.bankCardNumber = resData.data.bankCardNumber;
            this.bank_no = resData.data.bankCardNumber;
          }
        } else {
          this.$toast.warn(resData.data.msg);
        }
      }
    },
    showMsgFn(e) {
      var that = this;
      // console.log(e, "44444444");
    },
    saasorderbusinessmenPagePost() {
      http.post(config.signInfo).then((e) => {
        // console.log(e,'个体户详情')
        if (e.code == 0) {
          this.methodName = e.data.userName;
          this.methodNameUpdate = e.data.userName;
          if (e.data.idNo) {
            var idNo = e.data.idNo;
            this.idNumber = e.data.idNo;
            this.methodIdentityUpdate = e.data.idNo;
            this.methodIdentity = `${idNo.substring(
              0,
              4
            )}**********${idNo.substring(idNo.length - 4)}`;
          }

          // console.log(this.methodIdentity, "首次进来的身份证");
          // console.log(this.imgCode, "首次进来的code");
          if (e.data.idNoFront && this.imgCode == 2) {
            this.imgList1[0].id = 1;
            this.imgList1[0].src = e.data.idNoFront;
            this.idcardIsImg = e.data.idNoFront;
          } else {
            this.imgList1[0].id = 1;
            this.imgList1[0].src =
              "https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_383515910831670212020215324721idCodez.png";
            this.idcardIsImg = "";
          }
          if (e.data.idNoBack && this.imgCode == 2) {
            this.imgList2[0].id = 2;
            this.imgList2[0].src = e.data.idNoBack;
            this.idcardTheImg = e.data.idNoBack;
          } else {
            this.imgList2[0].id = 2;
            this.imgList2[0].src =
              "https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_1585159108359080520202153950805idCodeb.png";
            this.idcardTheImg = "";
          }

          if (e.data.idNo) {
            var bankNo = e.data.bankNo;
            this.bank_noed = e.data.bankNo;
            this.bankCardNumber = e.data.bankNo;

            this.bank_no = `${bankNo.substring(0, 4)}${"*".repeat(
              bankNo.length - 8
            )}${bankNo.length % 4 ? "" : ""}${bankNo.slice(-4)}`;
          }

          if (e.data.mobile) {
            var mobile = e.data.mobile;
            this.cellphoneNumber = e.data.mobile;
            this.bank_mobiled = e.data.mobile;
            this.bank_mobile = `${mobile.substring(0, 3)}****${mobile.substring(
              mobile.length - 4
            )}`;
          }

          if (this.imgCode == 3) {
            this.disabled = true;
          } else {
            this.disabled = false;
          }
        }
      });
    },
    back() {
      this.$router.go(-1); //返回上一层
    },
    getUploadConfig() {
      var that = this;
      http.post(config.uploadConfig).then(
        (d) => {
          // console.log(d, "阿里接口");
          that.data.d["Bucket"] = d.data.Bucket;
          that.data.d["OSSAccessKeyId"] = d.data.OSSAccessKeyId;
          that.data.d["signature"] = d.data.Signature;
          that.data.d["policy"] = d.data.policy;
          that.data.d["success_action_status"] = d.data.success_action_status;
          that.data.action = d.data.url;
        },
        (err) => {
          //error callback
        }
      );
    },
    //连接摄像头
    connectCamera() {
      navigator.getMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMeddia ||
        navigator.msGetUserMedia;
      let that = this;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
            audio: true,
          })
          .then(function (stream) {
            // console.log(stream);
            that.stream = stream;
            that.cameraState = true;
            that.stream =
              typeof stream.stop === "function"
                ? stream
                : stream.getTracks()[1];
            // console.log(that.stream);
            var smallVideo = $(".smallVideo")[0];
            var bigVideo = $(".bigVideo")[0];
            smallVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            bigVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            smallVideo.play();
            bigVideo.play();
          })
          .catch(function (err) {
            console.log(err);
          });
      }
      // 使用旧方法打开摄像头
      else if (navigator.getMedia) {
        navigator.getMedia(
          {
            video: true,
          },
          function (stream) {
            console.log(stream);
            that.stream = stream;
            that.cameraState = true;
            that.stream = stream.getTracks()[0];
            console.log(that.stream);
            var smallVideo = $(".smallVideo")[0];
            var bigVideo = $(".bigVideo")[0];
            smallVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            bigVideo.src = (window.URL || window.webkitURL).createObjectURL(
              stream
            );
            smallVideo.play();
            bigVideo.play();
          },
          function (err) {
            console.log(err);
          }
        );
      }
    },

    //关闭摄像头
    closeCamera() {
      this.cameraState = false;
      this.stream && this.stream.stop();
    },

    //点击拍摄或集鸽拍摄
    reCamera(foot_ring_sn) {
      console.log("拍照调用");
      var smallCanvas = $(".smallCanvas")[0];
      var smallContext = smallCanvas.getContext("2d");
      let smallVideo = $(".smallVideo")[0];
      smallContext.drawImage(smallVideo, 0, 0, 270, 200);
      //拍好的图片显示
      //smallCanvas.toDataURL('image/png').split(",")[1]
    },
    //
    nextStep() {
      if (this.imgCode == 3) {
        if (!this.idcardIsImged) {
          this.$toast.warn("请上传身份证人像面");
          return;
        }
      }

      if (!this.idcardIsImg) {
        this.$toast.warn("请上传身份证人像面");
        return;
      }

      if (!this.idcardTheImg) {
        this.$toast.warn("请上传身份证国徽面");
        return;
      }

      if (!this.methodName) {
        this.$toast.warn("请填写姓名");
        return;
      }

      if (!this.idNumber) {
        this.$toast.warn("请填写身份证号码");
        return;
      }

      if (!this.bankCardNumber) {
        this.$toast.warn("请填写银行卡号");
        return;
      }

      if (!this.cellphoneNumber) {
        this.$toast.warn("请填写银行预留手机号");
        return;
      }
      if (!this.agreeArguments) {
        this.$toast.warn("请勾选协议");
        return;
      }
      // console.log(this.methodIdentityUpdate, "11111");
      if (sessionStorage.getItem("esignappsid")) {
        if (this.methodIdentityUpdate != "") {
          // console.log(this.methodIdentityUpdate, this.methodIdentity, "44444");
          if (this.methodIdentityUpdate != this.idNumber) {
            this.$toast.warn("信息不一致");
            return;
          }
        }
      }

      if (
        this.bank_mobiled != null ||
        this.bank_noed != null ||
        this.methodNameUpdate != null
      ) {
        if (
          this.bank_mobiled == this.cellphoneNumber &&
          this.bank_noed == this.bankCardNumber &&
          this.methodNameUpdate == this.methodName
        ) {
          const url = "/transferList";
          this.$router.push({ path: url });
          return;
        }
      }
      http
        .post(config.saveAuthInfo, {
          idNoFront: this.idcardIsImg,
          idNoBack: this.idcardTheImg,
          idNo: this.idNumber,
          userName: this.methodName,
          bankNo: this.bankCardNumber,
          mobile: this.cellphoneNumber,
        })
        .then((e) => {
          // console.log(e, "1111111");
          if (e.code == 0) {
            const url = "/transferList";
            this.$router.push({ path: url });
          } else {
            this.$toast.warn(e.message);
          }
        });
    },
    //正面拍照
    tupian(e) {
      // console.log(e.code, "1111111");
      this.imgCode = e.code;
      // console.log(this.imgCode, "点击进来的code");
      // console.log(this.idcardIsImg, "555555555555");
      if (this.imgCode == 3) {
        this.idcardIsImged == null;
      }
      if (this.imgCode == 3) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      // console.log(this.idcardIsImged, "666666666666666");
      let tempFilePaths = e.msg[0];
      let that = this;
      that.idCardType = "front";
      this.uploadFile(tempFilePaths, function (data) {
        if (data) {
          that.methodIdentity = "";
          that.idNumber = "";
          that.idcardIsImg = data.uploadUrl;
          that.disabled = false;
          if (data.front.name) {
            that.methodName = data.front.name;
            that.methodNameUpdate = data.front.name;
          }
          if (data.front.idNo) {
            // var idNo = data.front.idNo;
            that.idNumber = data.front.idNo;
            that.methodIdentity = data.front.idNo;
            that.methodIdentityUpdate = data.front.idNo;
          }
        }
      });
    },
    //反面拍照
    tupian2(e) {
      this.imgCode = e.code;
      if (e.code == 3) {
        this.idcardTheImg = null;
      }
      let tempFilePaths = e.msg[0];
      let that = this;
      that.idCardType = "back";
      this.uploadFile(tempFilePaths, function (data) {
        if (data) {
          that.disabled = false;
          // console.log(data.back, "3333333");
          that.idcardTheImg = data.uploadUrl;
        }
      });
    },

    uploadFile(filePaths, cb) {
      if (this.imgCode != 3) {
        this.disabled = true;
        this.$toast.text("准备上传");
        var fd = new FormData();
        //文件必须声明在最后，否则异常
        fd.append("file", filePaths);
        fd.append("idCardSide", this.idCardType);
        // console.log(fd.get("file"), "判断是否传进去"); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
        let configed = {
          headers: { "Content-Type": "multipart/form-data" },
        }; //添加请求头
        this.$http.post(config.idCardOcr, fd, configed).then((res) => {
          if (res.data.code == 0) {
            // console.log(res.data.data, "55555555555");
            if (res.data.data.code == 200) {
              this.$toast.text("上传成功");
              this.disabled = false;
              var chars = res.data.data;
              // var result = chars.substring(chars.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), chars.indexOf('</Location>'));
              cb(chars);
            } else {
              this.disabled = true;
              this.$toast.warn(res.data.data.msg);
            }
          }
        });
      }
    },
  },
  created() { },
};
</script>



// WEBPACK FOOTER //
// src/pages/legalPerson/index.vue